const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Hervey Bay",

  webfeedDebuggerWebsiteUrl:
    "https://vantageherveybay.avid.com.au/now-selling/",
  webfeedConfig: {
    mode: "masterplan", // masterplan, feed
    type: "land" // land, packages, dwellings etc
  }
  // add other conf items below if needed
};
